exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 50;\n  background-color: #000;\n  opacity: 0.5;\n}\n.loading img {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 0.6rem;\n  height: 0.6rem;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.loading.nobg {\n  background-color: transparent;\n}\n.block {\n  display: block;\n}\n.hide {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./component/Loading/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./component/Loading/index.less
// module chunks = 0